import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { getYoutubeThumb } from 'core/utils';
import Play from 'core/icons/Play';
import { PlayWrapper } from './thumbStyles';
import OverlaySpinner from 'core/ui/OverlaySpinner';
import loadable from '@loadable/component';
const VideoOverlay = loadable(() => import(
	'../VideoOverlay'
), {
	fallback: <OverlaySpinner />
});
import { ResponsiveCheck } from 'core/providers/Responsive';

const MainVideo = ({
	url,
	name,
	id,
	dismissVideo,
	videoIsPlaying,
	videoTrigger,
}) => (
	<ResponsiveCheck>
		{({ isDesktop }) => (
			<Fragment>
				<img
					src={getYoutubeThumb(url)}
					alt={name}
					title={name}
					onClick={() => videoTrigger(id)}
					width={isDesktop ? "590" : "345"}
					height={isDesktop ? "390" : "230"}
				/>
				<PlayWrapper clear onClick={() => videoTrigger(id)}>
					<Play />
				</PlayWrapper>
				{ videoIsPlaying && (
					<VideoOverlay url={url} dismiss={dismissVideo} />
				) }
			</Fragment>
		)}
	</ResponsiveCheck>
);

MainVideo.propTypes = {
	url: PropTypes.string,
	name: PropTypes.string,
	id: PropTypes.number,
	dismissVideo: PropTypes.func,
	videoTrigger: PropTypes.func,
	videoIsPlaying: PropTypes.bool,
};

MainVideo.defaultProps = {};

export default MainVideo;
